export enum InvoiceType {
  ProFormaInvoice = 0,
  PurchaseInvoice = 1,
  CreditNote = -1,
}
